import { createSelector } from "reselect";
import get from "lodash/get";

export const verifyOTPDomain = state => get(state, "api.verifyOTP.data", {});
export const uiOTPDomain = state => get(state, "ui.otp", {});
export const verifyOTPSelector = createSelector(verifyOTPDomain, verifyOTP => {
  return verifyOTP;
});
export const verifiedSelector = createSelector(verifyOTPDomain, verifyOTP => {
  return verifyOTP.is_valid_otp;
});
export const isResendActivationEnabled = createSelector(uiOTPDomain, otp =>
  get(otp, "resend_activation", false)
);

export const makeSelectIsOTPVerified = () => verifiedSelector;
export const makeSelectIsResendActivationEnabled = () =>
  isResendActivationEnabled;
